import { Application } from 'pixi.js';
import { SceneManager } from './core/SceneManager.js';
import { EventBus } from './core/EventBus.js';
import { InputManager } from './core/InputManager.js';
import { DebugLog } from './core/DebugLog.js';
import { BootScene } from './scenes/BootScene.js';

// Game constants
export const GAME_WIDTH = 480;
export const GAME_HEIGHT = 270;
export const TILE_SIZE = 16;
export const SCALE = 3;

async function main() {
  DebugLog.info('main', 'Astral Crypts starting...');

  const app = new Application();
  await app.init({
    width: GAME_WIDTH,
    height: GAME_HEIGHT,
    backgroundColor: 0x0a0a0f,
    resolution: window.devicePixelRatio || 1,
    autoDensity: true,
    antialias: false,
    roundPixels: true,
  });

  // Add canvas to wrapper
  const wrapper = document.getElementById('game-canvas-wrapper');
  wrapper.appendChild(app.canvas);

  // Apply pixel-perfect scaling
  app.canvas.style.imageRendering = 'pixelated';
  resizeCanvas(app);
  window.addEventListener('resize', () => resizeCanvas(app));

  // Core systems
  const eventBus = new EventBus();
  const inputManager = new InputManager(app.canvas, eventBus);
  const sceneManager = new SceneManager(app, eventBus, inputManager);

  // Expose for debug
  window.__game = { app, sceneManager, eventBus, inputManager, debug: DebugLog };

  // Start with boot scene
  sceneManager.switchTo(new BootScene(sceneManager, eventBus));

  // Game loop
  app.ticker.add((ticker) => {
    const dt = ticker.deltaTime / 60; // normalize to seconds
    sceneManager.update(dt);
    inputManager.update();
  });

  DebugLog.info('main', 'Game initialized successfully');
}

function resizeCanvas(app) {
  const wrapper = document.getElementById('game-canvas-wrapper');
  const ww = wrapper.clientWidth;
  const wh = wrapper.clientHeight;
  const gameAspect = GAME_WIDTH / GAME_HEIGHT;
  const windowAspect = ww / wh;

  let scale;
  if (windowAspect > gameAspect) {
    scale = wh / GAME_HEIGHT;
  } else {
    scale = ww / GAME_WIDTH;
  }

  // Snap to integer scale for pixel-perfect rendering
  scale = Math.max(1, Math.floor(scale));

  const canvasW = GAME_WIDTH * scale;
  const canvasH = GAME_HEIGHT * scale;
  app.canvas.style.width = canvasW + 'px';
  app.canvas.style.height = canvasH + 'px';
}

main().catch(err => {
  console.error('Failed to start Astral Crypts:', err);
  DebugLog.error('main', 'Fatal error: ' + err.message);
});
